import { WarningIcon } from '@moia-dev/pace-icons'
import { useTranslation } from 'react-i18next'
import { MoiaEmptyState } from '../feedback/MoiaEmptyState'
import { MoiaTopBar } from '../navigation/MoiaTopBar/MoiaTopBar'
import { MoiaTopBarTitle } from '../navigation/MoiaTopBar/MoiaTopBarTitle'

type AccessDeniedViewProps = {
  pageName: string
}

export const AccessDeniedView = ({ pageName }: AccessDeniedViewProps) => {
  const { t } = useTranslation()
  return (
    <>
      <MoiaTopBar
        leading={
          <MoiaTopBarTitle
            icon={<WarningIcon />}
            title={t('patterns_accessDenied_title')}
          />
        }
      />
      <MoiaEmptyState
        title={pageName}
        description={
          <>
            {t('patterns_emptyStateDescription')}
            <br />
            {t('patterns_emptyStateCallToAction')}
          </>
        }
      />
    </>
  )
}
